import { Loader2, Save, Upload } from "lucide-react";

export const MEDIA_FIELDS = [
  { key: "logo_image", label: "Logo (menu & pied de page)", hintKey: null },
  { key: "hero_image", label: "Image du hero (haut de la page d'accueil)", hintKey: null },
  { key: "about_image", label: "Image — section Le Cabinet", hintKey: null },
  { key: "values_image", label: "Image — section Valeurs (arrière-plan discret)", hintKey: null },
  { key: "contact_image", label: "Image — section Contact (arrière-plan)", hintKey: null },
  { key: "video_url", label: "Vidéo de présentation", hintKey: "admin_video_hint" },
];

const inputCls =
  "w-full bg-white/[0.05] border border-white/15 focus:border-[var(--accent)] focus:outline-none px-3 py-2.5 text-sm transition-colors duration-300";

const isVideoFile = (v) => /\.(mp4|webm|mov)(\?|$)/i.test(v);
const isYoutube = (v) => /youtube\.com|youtu\.be/.test(v);

export const MediaField = ({ label, fieldKey, value, saving, uploading, onText, onFile, onSave, t, hint }) => {
  const backend = process.env.REACT_APP_BACKEND_URL;
  const src = value ? (value.startsWith("http") ? value : backend + value) : "";
  const showImagePreview = src && !isVideoFile(src) && !isYoutube(src);

  return (
    <div data-testid={`admin-media-${fieldKey}`} className="border border-white/10 bg-white/[0.02] p-5">
      <p className="font-mono2 text-[10px] uppercase tracking-[0.25em] text-white/40 mb-3">{label}</p>
      {showImagePreview && (
        <img src={src} alt={label} className="w-full h-36 object-cover mb-3 border border-white/10" />
      )}
      {src && isVideoFile(src) && (
        <video src={src} className="w-full h-36 object-cover mb-3 border border-white/10" muted />
      )}
      <input
        data-testid={`admin-media-${fieldKey}-url`}
        value={value}
        onChange={(e) => onText(e.target.value)}
        placeholder="https://…"
        className={inputCls}
      />
      <div className="flex flex-wrap gap-2 mt-3">
        <label
          data-testid={`admin-media-${fieldKey}-upload`}
          className="inline-flex items-center gap-2 text-xs border border-white/15 hover:border-[var(--accent)] hover:text-[var(--accent)] px-4 py-2.5 rounded-full cursor-pointer transition-colors duration-300"
        >
          {uploading ? <Loader2 size={13} className="animate-spin" /> : <Upload size={13} />}
          {uploading ? t("admin_uploading") : t("admin_upload")}
          <input
            type="file"
            accept="image/jpeg,image/png,image/webp,image/gif,video/mp4,video/webm,video/quicktime"
            className="hidden"
            data-testid={`admin-media-${fieldKey}-file`}
            onChange={(e) => {
              if (e.target.files[0]) onFile(e.target.files[0]);
              e.target.value = "";
            }}
          />
        </label>
        <button
          data-testid={`admin-media-${fieldKey}-save`}
          onClick={onSave}
          disabled={saving || uploading}
          className="inline-flex items-center gap-2 text-xs bg-[var(--accent)] hover:bg-[var(--accent-soft)] disabled:opacity-60 text-white font-semibold px-4 py-2.5 rounded-full transition-colors duration-300"
        >
          {saving ? <Loader2 size={13} className="animate-spin" /> : <Save size={13} />}
          {saving ? t("admin_saving") : t("admin_save")}
        </button>
      </div>
      {hint && <p className="mt-3 text-[11px] text-white/35 leading-relaxed">{hint}</p>}
    </div>
  );
};
